// @flow
import * as React from 'react';

import * as Updates from 'expo-updates';
import Constants from 'expo-constants';
import { BackHandler, Dimensions } from 'react-native';
import { Item, Input, Icon, Toast, Form } from 'native-base';
import { connect } from 'react-redux';

import Alert from '../../components/alert';
import CalCalDataApi from '../../api/CalCalDataApi';
//import DrawerLayout from 'react-native-gesture-handler/DrawerLayout';

//import WebPage from "../../stories/screens/WebPage";
import Summary from './summary';
//import DECamera from '../DEform/DECamera';
//import GLOBALS from '../../components/globals';

import diff from 'object-diff';

//import t from 'tcomb-form-native';
//const TForm = t.form.Form;
//import styles from './styles';

// Change these to reflect
const DASH_URL = 'https://calc.al/staging/?nomenu';

class DashboardContainer extends React.Component<Props, State> {
	constructor(props) {
		super(props);
		this.initialState = {
			isLoading: false,
			canGoBack: false,
			currYear: null,
			loadingBalances: false,
			loadingYearTotals: false,
			loadedYear: null
		};
		this.state = this.initialState;
	}

	componentDidMount() {
		this.loadBalances();
		this._checkUpdates();
	}

	doRefresh() {
		this.loadBalances();
		this.loadYearTotals(this.props.taxyear);
		//this.loadLatestInvoices();
	}

	_checkUpdates = async () => {
		if (__DEV__) console.log('Checking for an update...');

		try {
			const update = await Updates.checkForUpdateAsync();
			if (update.isAvailable) {
				if (__DEV__) console.log('An update was found, downloading...', update.manifest);
				var apkver = update.manifest.version.split('.')[1];
				if (apkver == Constants.manifest.version.split('.')[1]) {
					await Updates.fetchUpdateAsync();
					Alert.alert(
						'CalCal Update',
						'There is an update to the mobile app. Click reload to restart with shiny new features.',
						[
							{
								text: 'Reload',
								onPress: () => {
									Updates.reloadAsync();
								}
							}
						],
						{ cancelable: true }
					);
				} else {
					if (__DEV__) console.log('new release - must update app');
					Alert.alert('CalCal Update', 'There is an update to the mobile app. Please update in the app store.');
				}
			} else {
				if (__DEV__) console.log('No updates were found');
			}
		} catch (e) {
			if (__DEV__) console.log('Error while trying to check for updates', e);
		}
	};

	loadYearTotals(y) {
		if (!this.loadingYearTotals) {
			this.loadingYearTotals = true;
			this.setState({ yearTotals: null, taxTotals: null });

			CalCalDataApi.dataLoad('yearTotals/' + y, this.props.jwt, res => {
				if (!res.error && !res.exception) this.setState({ yearTotals: res, loadedYear: y });
				this.loadingYearTotals = false;
				if (__DEV__) console.log('yearTotals ', res);
				//this.setState({ currYear: y });
			});
		}
		if (!this.loadingTaxTotals) {
			this.loadingTaxTotals = true;
			CalCalDataApi.dataLoad('yearTotals/tax/' + y, this.props.jwt, res => {
				this.loadingTaxTotals = false;
				if (!res.error && !res.exception) this.setState({ taxTotals: res });
			});
		}
	}

	loadBalances() {
		//this.setState({ loadingBalances: true });
		CalCalDataApi.dataLoad('accounts/balances', this.props.jwt, res => {
			//this.setState({ loadingBalances: false });
			if (!res.error && !res.exception) {
				const tot = res.reduce((tot, bal) => (bal ? tot + Number(bal.value) : tot), 0);
				res.push({ label: 'Total Current Assets', value: tot });
				this.setState({ balances: res });
			}
		});
	}

	loadLatestInvoices() {
		console.log('latest invoices');
		CalCalDataApi.dataLoad('invoices/top:9', this.props.jwt, res => {
			this.setState({ invoices: res });
		});
	}

	setYear(y) {
		//on press of one of the years
		if (__DEV__) console.log('setting year', y);

		this.props.dispatch({
			type: 'SET_TAXYEAR',
			taxyear: Number(y)
		});
	}

	renderDECam() {
		return <DECamera />;
	}

	render() {
		const { taxyear } = this.props;
		const { taxTotals, yearTotals, loadedYear, invoices } = this.state;

		if (taxyear && (!taxTotals || taxyear != loadedYear)) this.loadYearTotals(taxyear);

		return (
			<Summary
				title="?"
				navigation={this.props.navigation}
				currYear={taxyear}
				years={this.props.years}
				profitbymonth={this.props.profitbymonth}
				customers={this.props.customers}
				setYear={y => this.setYear(y)}
				yearTotals={yearTotals}
				taxTotals={taxTotals}
				balances={this.state.balances}
				doRefresh={() => this.doRefresh()}
				refreshing={!taxTotals}
			/>
		);
	}
}

const mapStateToProps = state => ({
	user: state.loginReducer.user,
	years: state.globalReducer.yrs,
	profitbymonth: state.globalReducer.profitbymonth,
	jwtLoaded: state.loginReducer.loaded,
	jwt: state.loginReducer.jwt && state.loginReducer.jwt.token,
	customers: state.globalReducer.customers,
	taxyear: state.reportsReducer.taxyear
});

export default connect(mapStateToProps)(DashboardContainer);
